import { useMemo, useState } from 'react';

import { Grid } from '@mui/material';

import { navigate } from '@redwoodjs/router';
import { MetaTags, useQuery } from '@redwoodjs/web';

import Loader from 'src/components/Loader/Loader';
import TableList from 'src/components/TableList/TableList';
import { CREDITS_TABLE_HEADERS } from 'src/constants';
import { CREDIT_NOTES } from 'src/graphql/queries/creditNotes.query';
import { PageContent } from 'src/layouts/MainLayout/PageContent';
import {
    creditNotesFilterOptions,
    creditsFilteredTableData,
    updateTableFilters,
} from 'src/utils/tableUtils';
import { onError } from 'src/utils/utils';

const ViewCreditsPage = () => {
    const [tableFilters, setTableFilters] = useState({});

    const { data, loading } = useQuery(CREDIT_NOTES, {
        fetchPolicy: 'cache-and-network',
        onError,
    });

    // Handle add merchant
    const handleAddRecord = () => {
        navigate('/finance/credits/add');
    };

    const tableData = useMemo(() => {
        return creditsFilteredTableData(data, tableFilters).reverse();
    }, [data, tableFilters]);

    const filterOptions = () => {
        return creditNotesFilterOptions(data);
    };

    const handleViewCredit = ({ id }) => {
        navigate(`/finance/credits/${id}`);
    };

    return (
        <PageContent heading="Credits" subHeading="View NPI Credits">
            <MetaTags title="Credits" description="Credits Page" />
            {loading && <Loader />}

            <Grid container sx={{ gap: '24px' }}>
                <Grid item xs={12}>
                    {/* TODO: Display loader if data is still fetching */}
                    <TableList
                        addRecordButtonText="Add Credit"
                        data={tableData}
                        headers={CREDITS_TABLE_HEADERS}
                        title="Credits List"
                        addRecordCallBack={handleAddRecord}
                        handleViewRecord={handleViewCredit}
                        deleteRecordCallBack={() => {}}
                        enableFilter
                        enableExport
                        filterOptions={filterOptions()}
                        updateTableFilters={(filter: string, newFilterValue: string) =>
                        {return setTableFilters((prevFilters) =>
                        {return updateTableFilters(prevFilters, newFilterValue, filter);}
                        );}
                        }
                    />
                </Grid>
            </Grid>
        </PageContent>
    );
};

export default ViewCreditsPage;
